import classNames from 'classnames';
import CVItem from '../../components/CV/CVItem';
import { useState } from 'react';
import loadingGif from '../../assets/Other/loading.gif';
import {
  controllers,
  requestTypes,
  responseTypes,
} from '../../constants/enums/API';
import request from '../../utils/APIHelper/request';
import { toast } from 'react-toastify';

const OdooPortalSync = () => {
  const [presentedShipments, setPresentedShipments] = useState([]);
  const [syncedShipments, setSyncedShipments] = useState([]);
  const [missingShipments, setMissingShipments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [CVs, setCVs] = useState([]);
  const [CVInput, SetCVInput] = useState('');
  const onRemoveMethod = (index) => {
    setCVs(CVs.filter((_, i) => i !== index));
  };

  const onEnterMethod = () => {
    const trimmedCVInput = CVInput.trim().toUpperCase();

    const sanitizedInput = trimmedCVInput.replace(/[^A-Z0-9]/g, '');

    if (
      sanitizedInput.length > 0 &&
      !CVs.includes(sanitizedInput) &&
      CVs.length < 10
    ) {
      setCVs([...CVs, sanitizedInput]);
      SetCVInput('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onEnterMethod();
    }
  };

  const download = async () => {
    setPresentedShipments([]);
    setSyncedShipments([]);
    setMissingShipments([]);
    if (CVs.length > 0) {
      const result = await request({
        url: `${controllers.shipments}odooPortalShipmentsSync`,
        type: requestTypes.post,
        body: CVs,
        setLoading,
        disableLogOut: false,
      });
      if (result?.code === responseTypes.success) {
        console.log('Success:', result);
        setPresentedShipments(result?.result?.presented);
        setSyncedShipments(result?.result?.synced);
        setMissingShipments(result?.result?.missing);
        if (result?.result?.presented?.length > 0) {
          toast.warning(
            `Shipments ${result?.result?.presented?.join(', ')} are already presented in Agent Portal`,
          );
        }
        if (result?.result?.synced?.length > 0) {
          toast.success(
            `Shipments ${result?.result?.synced?.join(', ')} just have been sucessfully synced in ODOO and Agent Portal`,
          );
        }
        if (result?.result?.missing?.length > 0) {
          toast.error(
            `Shipments ${result?.result?.missing?.join(', ')} are missing in ODOO, so they cannot be copied to Agent Portal`,
          );
        }
      } else if (result?.code === responseTypes.error) {
        toast.error(
          `Shipment data in Odoo is missing fields or isn’t formatted correctly for the Agent Portal`,
        );
      } else {
        toast.error(`Something went wrong while sync process!`);
      }
    }
  };

  return (
    <div>
      <div className="text-xl text-blue-800 flex justify-center mb-10">
        ODOO-PORTAL SYNC
      </div>
      <div className="w-1/2 xl:w-[500px] min-h-[110px] mx-auto my-10 xl:my-0 relative">
        <input
          value={CVInput}
          onKeyDown={handleKeyPress}
          onChange={(e) => SetCVInput(e.target.value)}
          type="text"
          placeholder="Enter CV..."
          className="w-[90%] p-2 border-b border-b-blue-700 rounded-t-[20px] focus:outline-none focus:border-blue-400 text-xs"
        />
        <div
          onClick={onEnterMethod}
          className="absolute text-white bg-blue-900 p-[8.5px] px-4 top-0 right-0 text-xs cursor-pointer rounded-r-xl rounded-tl-xl"
        >
          ENTER
        </div>
        <div className="w-full text-left px-2 py-1 text-sm pb-10">
          {CVs.map((item, index) => {
            return (
              <CVItem
                key={index}
                number={item}
                onRemove={() => onRemoveMethod(index)}
              />
            );
          })}
        </div>
        <div className="absolute bottom-1 w-full text-center">
          <div
            onClick={download}
            className={classNames(
              'bg-red-800 text-white inline-block px-10 rounded-[20px] cursor-pointer hover:bg-red-900 hover:transition-all hover:duration-300 text-sm xl:text-sm',
              loading ? 'hidden' : null,
            )}
          >
            SYNC DATA
          </div>
          <div
            className={classNames(
              'w-full flex justify-center items-center',
              !loading ? 'hidden' : null,
            )}
          >
            <img className="w-8 h-8" src={loadingGif} />
          </div>
        </div>
      </div>
      <div className="w-1/2 xl:w-[500px] min-h-[110px] mx-auto my-10 xl:my-0 relative">
        {presentedShipments?.length > 0 ? (
          <div className="text-left my-3 text-orange-400">
            {`Shipments ${presentedShipments?.join(', ')} are already presented in Agent Portal`}
          </div>
        ) : null}
        {syncedShipments?.length > 0 ? (
          <div className="text-left my-3 text-green-700">
            {`Shipments ${syncedShipments?.join(', ')} just have been sucessfully synced in ODOO and Agent Portal`}
          </div>
        ) : null}
        {missingShipments?.length > 0 ? (
          <div className="text-left my-3 text-red-700">
            {`Shipments ${missingShipments?.join(', ')} are missing in ODOO, so they cannot be copied to Agent Portal`}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default OdooPortalSync;
